/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getAccountingBankAccounts } from 'app/entities/accounting-bank-account/accounting-bank-account.reducer';
import { createEntity, getEntity, reset, updateEntity } from './accounting-currency.reducer';

export const AccountingCurrencyUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const accountingBankAccounts = useAppSelector(state => state.accountingBankAccount.entities);
  const accountingCurrencyEntity = useAppSelector(state => state.accountingCurrency.entity);
  const loading = useAppSelector(state => state.accountingCurrency.loading);
  const updating = useAppSelector(state => state.accountingCurrency.updating);
  const updateSuccess = useAppSelector(state => state.accountingCurrency.updateSuccess);

  const handleClose = () => {
    navigate(`/accounting-currency${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getAccountingBankAccounts({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.precision !== undefined && typeof values.precision !== 'number') {
      values.precision = Number(values.precision);
    }
    if (values.subUnit !== undefined && typeof values.subUnit !== 'number') {
      values.subUnit = Number(values.subUnit);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...accountingCurrencyEntity,
      ...values,
      accounts: mapIdList(values.accounts),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...accountingCurrencyEntity,
          accounts: accountingCurrencyEntity?.accounts?.map(e => e.id.toString()),
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.accountingCurrency.home.createOrEditLabel" data-cy="AccountingCurrencyCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.accountingCurrency.home.createOrEditLabel">
              Create or edit a AccountingCurrency
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="accounting-currency-id"
                  label={translate('tinyMedicRestApp.accountingCurrency.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.accountingCurrency.codeString')}
                id="accounting-currency-codeString"
                name="codeString"
                data-cy="codeString"
                type="text"
              />
              <UncontrolledTooltip target="codeStringLabel">
                <Translate contentKey="tinyMedicRestApp.accountingCurrency.help.codeString" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.accountingCurrency.name')}
                id="accounting-currency-name"
                name="name"
                data-cy="name"
                type="text"
              />
              <UncontrolledTooltip target="nameLabel">
                <Translate contentKey="tinyMedicRestApp.accountingCurrency.help.name" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.accountingCurrency.code')}
                id="accounting-currency-code"
                name="code"
                data-cy="code"
                type="text"
              />
              <UncontrolledTooltip target="codeLabel">
                <Translate contentKey="tinyMedicRestApp.accountingCurrency.help.code" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.accountingCurrency.precision')}
                id="accounting-currency-precision"
                name="precision"
                data-cy="precision"
                type="text"
              />
              <UncontrolledTooltip target="precisionLabel">
                <Translate contentKey="tinyMedicRestApp.accountingCurrency.help.precision" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.accountingCurrency.subUnit')}
                id="accounting-currency-subUnit"
                name="subUnit"
                data-cy="subUnit"
                type="text"
              />
              <UncontrolledTooltip target="subUnitLabel">
                <Translate contentKey="tinyMedicRestApp.accountingCurrency.help.subUnit" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.accountingCurrency.symbol')}
                id="accounting-currency-symbol"
                name="symbol"
                data-cy="symbol"
                type="text"
              />
              <UncontrolledTooltip target="symbolLabel">
                <Translate contentKey="tinyMedicRestApp.accountingCurrency.help.symbol" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.accountingCurrency.symbolFirst')}
                id="accounting-currency-symbolFirst"
                name="symbolFirst"
                data-cy="symbolFirst"
                check
                type="checkbox"
              />
              <UncontrolledTooltip target="symbolFirstLabel">
                <Translate contentKey="tinyMedicRestApp.accountingCurrency.help.symbolFirst" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.accountingCurrency.decimalMark')}
                id="accounting-currency-decimalMark"
                name="decimalMark"
                data-cy="decimalMark"
                type="text"
              />
              <UncontrolledTooltip target="decimalMarkLabel">
                <Translate contentKey="tinyMedicRestApp.accountingCurrency.help.decimalMark" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.accountingCurrency.thousandsSeparator')}
                id="accounting-currency-thousandsSeparator"
                name="thousandsSeparator"
                data-cy="thousandsSeparator"
                type="text"
              />
              <UncontrolledTooltip target="thousandsSeparatorLabel">
                <Translate contentKey="tinyMedicRestApp.accountingCurrency.help.thousandsSeparator" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.accountingCurrency.country')}
                id="accounting-currency-country"
                name="country"
                data-cy="country"
                type="text"
              />
              <UncontrolledTooltip target="countryLabel">
                <Translate contentKey="tinyMedicRestApp.accountingCurrency.help.country" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.accountingCurrency.active')}
                id="accounting-currency-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <UncontrolledTooltip target="activeLabel">
                <Translate contentKey="tinyMedicRestApp.accountingCurrency.help.active" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.accountingCurrency.cursor')}
                id="accounting-currency-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="cursorLabel">
                <Translate contentKey="tinyMedicRestApp.accountingCurrency.help.cursor" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.accountingCurrency.lastUpdated')}
                id="accounting-currency-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="lastUpdatedLabel">
                <Translate contentKey="tinyMedicRestApp.accountingCurrency.help.lastUpdated" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.accountingCurrency.microSec')}
                id="accounting-currency-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="microSecLabel">
                <Translate contentKey="tinyMedicRestApp.accountingCurrency.help.microSec" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.accountingCurrency.timestampEntry')}
                id="accounting-currency-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="timestampEntryLabel">
                <Translate contentKey="tinyMedicRestApp.accountingCurrency.help.timestampEntry" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.accountingCurrency.account')}
                id="accounting-currency-account"
                data-cy="account"
                type="select"
                multiple
                name="accounts"
              >
                <option value="" key="0" />
                {accountingBankAccounts
                  ? accountingBankAccounts.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/accounting-currency" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default AccountingCurrencyUpdate;
